import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

/** Contact details from https://www.liberateglobal.com/contact */
export const LIBERATE_CONTACT = {
  salesEmail: 'sales@liberateglobal.com',
  phoneAustralia: '1300 448 060',
  phoneEurope: '+41 41 749 16 16',
  hours: 'Mon–Fri, 8am to 5pm',
  address: '941 West Morse Blvd, Suite 100',
  city: 'Winter Park, Florida 32789, USA',
  website: 'https://www.liberateglobal.com/',
  contactPage: 'https://www.liberateglobal.com/contact',
};

export const LIBERATE_OFFICES = [
  {
    region: 'Florida (HQ)',
    company: 'MPS North America LLC',
    lines: ['941 West Morse Blvd, Suite 100', 'Winter Park, Florida 32789, USA'],
  },
  {
    region: 'Melbourne',
    company: 'Liberate',
    lines: ['Level 2, 161 Collins Street', 'Melbourne, VIC 3000'],
  },
  {
    region: 'Baar',
    company: 'Liberate',
    lines: ['Inwilerriedstrasse 61', '6340 Baar, Switzerland'],
  },
  {
    region: 'Mumbai',
    company: 'MPS Limited',
    lines: ['Unit no. 902, Tower-D, Times Square Building', 'Andheri (East), Mumbai-400059'],
  },
];

export const LIBERATE_CONTACT_CARDS = [
  {
    icon: FaEnvelope,
    title: 'Chat With Sales',
    lines: [LIBERATE_CONTACT.salesEmail],
    href: `mailto:${LIBERATE_CONTACT.salesEmail}`,
  },
  {
    icon: FaPhone,
    title: 'Call Us',
    lines: [
      LIBERATE_CONTACT.hours,
      `AUS: ${LIBERATE_CONTACT.phoneAustralia}`,
      `EU: ${LIBERATE_CONTACT.phoneEurope}`,
    ],
  },
  {
    icon: FaMapMarkerAlt,
    title: 'Head Office',
    lines: [LIBERATE_CONTACT.address, LIBERATE_CONTACT.city],
  },
  {
    icon: FaGlobe,
    title: 'Website',
    lines: ['liberateglobal.com'],
    href: LIBERATE_CONTACT.website,
  },
];

/** Awards from https://www.liberateglobal.com/ — “Raising the Bar with Our Clients” */
export const LIBERATE_AWARDS = [
  {
    value: '430',
    title: 'Brandon Hall Group Awards',
    description: 'Industry recognition for excellence in learning and talent development.',
  },
  {
    value: '85',
    title: 'eLearning Industry Rankings',
    description: 'Ranked among top providers shaping modern eLearning worldwide.',
  },
  {
    value: '35',
    title: 'Training Industry Rankings',
    description: 'Recognized for impact across corporate training and L&D services.',
  },
  {
    value: '25',
    title: 'LearnX Live Awards',
    description: 'Award-winning learning design and delivery across programs.',
  },
  {
    value: '5',
    title: 'AITD Recognitions',
    description: 'Australian Institute of Training and Development acknowledgements.',
  },
  {
    value: '600+',
    title: 'Global Awards & Rankings',
    description: 'Three decades of recognition across verticals and geographies.',
  },
];

/**
 * Testimonials from https://www.liberateglobal.com/
 * “What Our Customers Say About Liberate”
 */
export const LIBERATE_TESTIMONIALS = [
  {
    name: 'Jennifer Zaborowski',
    role: 'Director, IT L&D, Regeneron Pharmaceuticals',
    content:
      'Liberate has been a strategic partner from the start, helping us build a robust IT training library from scratch. Their team is familiar with our user base and creates engaging, concise, and effective learning experiences. What truly sets them apart is their collaboration and anticipation of our needs, making the process much easier. After nearly five years, they continue to be friendly, expert, and creative collaborators. It’s a wonderful, fruitful partnership.',
  },
  {
    name: 'Jay Patel',
    role: 'Manager, Learning Solutions',
    content:
      'I’ve worked with the team across my roles at NAB, Australia Post, and Orica. They consistently delivered reliable projects and a positive experience. Their partnership on our global L&D services has been seamless. They operate as a true extension of our internal team, managing the learning lifecycle effectively. A world-class partner and a valued part of our global team.',
  },
  {
    name: 'Wayne Williams',
    role: 'Learning Lead, Enterprise Learning',
    content:
      'I’ve partnered with the team since 2015, first at Cenovus Energy and now at Suncor Energy. Their professionalism, agility, and learning expertise have always impressed me. They consistently go beyond expectations to deliver exceptional learning experiences. Our partnership is built on trust and shared accountability. It continues to strengthen the capability and impact of our learning function.',
  },
  {
    name: 'Louise Stuart',
    role: 'National Capability Manager, Suncorp Personal Injury Claims',
    content:
      'Innovative, trailblazing, and inspiring partnership. Together we delivered a top-quality orientation module that reinvigorated the learning experience for new starters. The module introduced interactive elements, gamification, and contextualized content. It created a strong sense of belonging, excitement, and purpose. A fantastic first impression and introduction to our business.',
  },
  {
    name: 'Rick Housler',
    role: 'Senior Learning Specialist, World Bank Group',
    content:
      'Over the past decade, the World Bank’s collaboration with Liberate has been instrumental in developing effective eLearning courses that support key projects for both staff and external clients. This partnership has enabled the bank to deliver high-quality, accessible training solutions that enhance knowledge, build capacity, and ensure consistent understanding of critical procedures and instruments across diverse teams and geographies.',
  },
  {
    name: 'Keabetswe Maseko',
    role: 'Learning Project Manager, Anglo American, UK',
    content:
      'The team really makes my job easier as a Project manager and I have complete confidence in their ability to deliver exceptional results. With upcoming new projects, we will definitely be knocking at their front door as they are currently my most preferred vendor to work with.',
  },
];

export const CATEGORY_DATA = {
  all: { name: 'All Courses', icon: '📚' },
  1: { name: 'Business Management', icon: '💼' },
  2: { name: 'Technology and Programming', icon: '💻' },
  3: { name: 'Personal Development', icon: '🌱' },
  4: { name: 'Workplace Skills', icon: '🛠️' },
};

export const getCategoryLabel = (categoryId) =>
  CATEGORY_DATA[categoryId]?.name || CATEGORY_DATA[Number(categoryId)]?.name || 'Uncategorized';
